import { addToCart } from '@/commons/api/cart-actions';

/**
 * CUBE Library "entry point"
 * `init` function will :
 *    - create a new `cube` object
 *    - assign it in the global `window.cube` object (this extends the original `cube` variable)
 */
export const init = () => {
  // init a `cube` extension
  const cube = {
    api: { addToCart },
  };

  // effectively extends the global `cube` object
  window.cube = Object.assign(window.cube || {}, cube);
};



// WEBPACK FOOTER //
// ./src/commons/lib-cube.js